/* Saved items: give the saved cards the same quick view the product cards have.

   assets/global.js builds the saved cards from localStorage, so it only knows the title,
   price, image and ONE variant id. That is how "Move to bag" used to drop a Sage Hoopla
   into the bag for someone who had saved it meaning to pick Blush.

   sections/main-wishlist.liquid prints a pool of quick view payloads keyed by handle,
   rendered from snippets/qv-payload.liquid, the same snippet the product cards use. This
   file copies the matching entry into each saved card as <script data-qv-data>, which is
   what assets/quick-view.js reads. A colorway product then opens the chooser.

   It runs as an enhancer rather than a rewrite of renderWishlist, so global.js stays the
   single owner of the list itself and nothing here can break the plain list if the pool
   is missing.
*/
(function () {
  var grid = document.querySelector('[data-wishlist-grid]');
  var poolTag = document.querySelector('[data-qv-pool]');
  if (!grid || !poolTag) return;

  var pool = {};
  try { pool = JSON.parse(poolTag.textContent) || {}; } catch (e) { return; }

  var EYE = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" ' +
    'stroke-width="1.55" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M2 12s3.8-6.5 10-6.5S22 12 22 12s-3.8 6.5-10 6.5S2 12 2 12z"/>' +
    '<circle cx="12" cy="12" r="3"/></svg>';

  function handleOf(card) {
    var rm = card.querySelector('[data-wl-remove]');
    if (rm) return rm.getAttribute('data-wl-remove');
    var add = card.querySelector('[data-wl-add]');
    if (add) return add.getAttribute('data-handle');
    return null;
  }

  function enhance(card) {
    if (card.querySelector('[data-qv-data]')) return;
    var handle = handleOf(card);
    if (!handle) return;
    var data = pool[handle];
    if (!data) return;               // sold out or archived since it was saved

    var tag = document.createElement('script');
    tag.type = 'application/json';
    tag.setAttribute('data-qv-data', '');
    tag.textContent = JSON.stringify(data);
    card.appendChild(tag);

    // the eye has to sit inside the IMAGE, so give the image its own frame first.
    // anchored to .card it would land on the buttons underneath.
    var img = card.querySelector('.card__img');
    if (img && !card.querySelector('.card__frame')) {
      var frame = document.createElement('div');
      frame.className = 'card__frame';
      img.parentNode.insertBefore(frame, img);
      frame.appendChild(img);

      var eye = document.createElement('a');
      eye.className = 'card__view';
      eye.href = data.url;
      eye.setAttribute('data-qv-open', '');
      eye.title = 'Quick view';
      eye.setAttribute('aria-label', 'Quick view of ' + data.title);
      eye.innerHTML = EYE;
      frame.appendChild(eye);
    }

    // a colorway product must never add straight from here
    if (data.hasColor) {
      var addBtn = card.querySelector('[data-wl-add]');
      if (addBtn) {
        var pick = document.createElement('a');
        pick.className = addBtn.className;
        pick.href = data.url;
        pick.setAttribute('data-qv-open', '');
        pick.style.display = 'flex';
        pick.style.alignItems = 'center';
        pick.style.justifyContent = 'center';
        pick.style.textDecoration = 'none';
        pick.textContent = 'Choose colorway';
        addBtn.parentNode.replaceChild(pick, addBtn);
      }
    }
  }

  function sweep() {
    var cards = grid.querySelectorAll('.card');
    for (var i = 0; i < cards.length; i++) { enhance(cards[i]); }
  }

  new MutationObserver(sweep).observe(grid, { childList: true });
  sweep();
})();
